<template>
  <div id="Refill">
    <b-navbar type="light" variant="light-success">
      <b-button v-b-toggle.sidemenu variant="outline-secondary" class="mr-2 d-lg-none"><f-icon icon="bars"></f-icon></b-button>
      <b-navbar-brand  class="mb-0" :to="{ path: '/ld' }" replace>
        <img :src="logoImg" class="d-inline-block align-top" alt="Logo" height="30px">
        {{ logoName }}
      </b-navbar-brand>
    </b-navbar>
    <b-sidebar id="sidemenu" title="Menu" body-class="px-2" shadow>
      <left-menu></left-menu>
    </b-sidebar>
    <b-container fluid class="bg-white shadow-sm">
      <b-row>
        <b-col cols="3" class="d-none d-lg-block pb-4 pt-2">

          <left-menu></left-menu>
        </b-col>
        <b-col lg="9" class="pt-4 pb-4 animate__animated animate__fadeIn">
          <!-- <alert-card></alert-card> -->
          <b-card class="mb-2" bg-variant="gra-ye-or">
            <h2>รายการรอการอนุมัติเติมเงิน</h2>

            <b-overlay
              id="overlay-dataSlipReady"
              :show="!dataSlipReady"
              variant="warning"
              :opacity="0.95"
              blur="4px"
              rounded="sm"
            >
              <template #overlay>
                <div class="text-center">
                  <h4 id="cancel-label">กำลังเรียกดูข้อมูล</h4>
                </div>
              </template>

              <b-table striped bordered small responsive
                table-variant="warning"
                :items="topUpItems" :fields="topUpFields"
                show-empty empty-text="ไม่พบการเติมเงิน"
                class="table-mini">

                <template #cell(showDetails)="row">
                  <b-button size="sm" @click="row.toggleDetails" variant="info">
                    <f-icon icon="receipt"></f-icon> {{ row.detailsShowing ? 'ซ่อน' : 'แสดง' }}สลิป
                  </b-button>
                </template>

                <template #cell(approveSlip)="data">
                  <b-button @click="approveTopUp(data.item)" size="sm" :disabled="!dataReady" variant="success">
                    <f-icon icon="check"></f-icon> ยืนยันยอดเงิน
                  </b-button>
                  <b-button @click="cancelTopUp(data.item)" size="sm" :disabled="!dataReady" variant="danger">
                    <f-icon icon="times"></f-icon> ปฏิเสธยอดเงิน
                  </b-button>
                </template>

                <template #row-details="row">
                    <b-row class="my-2">
                      <b-col>
                        <b-img thumbnail fluid width="300" center
                          :src="row.item.pictureSlipTopUp" v-if="row.item.pictureSlipTopUp"
                          alt="หลักฐานการโอนเงิน"></b-img>
                      </b-col>
                    </b-row>
                </template>

              </b-table>

            </b-overlay>
          </b-card>

          <b-card class="mb-2" bg-variant="gra-gr-bl">
            <h2>รายการอนุมัติเติมเงิน</h2>

            <b-overlay
              id="overlay-dataApproveReady"
              :show="!dataApproveReady"
              variant="success"
              :opacity="0.95"
              blur="4px"
              rounded="sm"
            >
              <template #overlay>
                <div class="text-center">
                  <h4 id="cancel-label">กำลังเรียกดูข้อมูล</h4>
                </div>
              </template>

              <b-table striped bordered small responsive
                :items="approveItems" :fields="approveFields"
                table-variant="success"
                show-empty empty-text="ไม่พบการเติมเงิน"
                class="table-mini">

                <template #cell(lastDatetime)="data">
                  {{ data.value.date }} {{ data.value.time }}
                </template>

                <template #cell(showDetails)="row">
                  <b-button size="sm" @click="row.toggleDetails" variant="info">
                    <f-icon icon="receipt"></f-icon> {{ row.detailsShowing ? 'ซ่อน' : 'แสดง' }}สลิป
                  </b-button>
                </template>

                <template #row-details="row">
                    <b-row class="my-2">
                      <b-col>
                        <b-img thumbnail fluid width="300" center
                          :src="row.item.pictureSlipTopUp" v-if="row.item.pictureSlipTopUp"
                          alt="หลักฐานการโอนเงิน"></b-img>
                      </b-col>
                    </b-row>
                </template>

              </b-table>

            </b-overlay>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid class="text-center mt-3 mb-2">
      {{ footerLC }}
    </b-container>
  </div>
</template>

<script>
import axios from "axios"; // api
import MenuBar from '@/components/Menubar' // เมนู
import AlertCard from '@/components/Alert' // แจ้งเดือน
export default {
  name: "Refill",
  components: {
    'left-menu': MenuBar,
    'alert-card': AlertCard
  },
  beforeCreate() {
    // เหตุการจะเกิดขึ้นก่อนที่ Component จะถูก render เข้าไปใน DOM
    // this.$liff.init({ liffId: this.$liff_register_profile }, function (data) {})
  },
  created() {
    // ทุกอย่างจะถูกเตรียมไว้ครบหมดแล้ว และสามารถเข้าถึงได้หมด
    // setInterval(this.getDataMap, 1000)
  },
  async mounted() {
    // จะเกิดขึ้นเมื่อ DOM ถูกสร้างเสร็จแล้ว เราสามารถ เข้าถึง Element ต่างๆใน DOM ได้ทั้งหมด
    // เช่นการ ดึงข้อมูลจาก input เป็นต้น
    this.getDataUser()
    await this.getDataTopUp()
    await this.getDataApproveTopUp()
  },
  data() {
    return {
      options: [
          { text: 'แอดมิน', value: 'A' },
          { text: 'ผู้ใช้ทั่วไป', value: 'U' },
      ],
      topUpFields: [
        // { key: 'createSliptime', label: 'แจ้งชำระมาเมื่อ' },
        { key: 'userCode', label: 'รหัสสมาชิก' },
        { key: 'transferDate', label: 'วันที่เติมเงิน', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'transferTime', label: 'เวลาเติมเงิน', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'amount', label: 'จำนวนเงิน' },
        { key: 'noteSlipTopUp', label: 'รายละเอียดเพิ่มเติม' },
        { key: 'showDetails', label: 'หลักฐานสลิป' },
        { key: 'approveSlip', label: 'อนุมัติการเติมเงิน', thClass: 'text-center', tdClass: 'text-center' },
      ],
      approveFields: [
        // { key: 'createSliptime', label: 'แจ้งชำระมาเมื่อ' },
        { key: 'userCode', label: 'รหัสสมาชิก' },
        { key: 'transferDate', label: 'วันที่เติมเงิน', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'transferTime', label: 'เวลาเติมเงิน', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'amount', label: 'จำนวนเงิน' },
        { key: 'noteSlipTopUp', label: 'รายละเอียดเพิ่มเติม' },
        { key: 'lastDatetime', label: 'อนุมัติเมื่อ'},
        { key: 'showDetails', label: 'หลักฐานสลิป' },
      ],
      topUpItems: [],
      approveItems: [],
      userData: {
        userName: '',
        firstName: '',
        lastName: '',
        telephoneNumber: '',
        userType: ''
      },
      dataReady: false,
      dataApproveReady: false,
      dataSlipReady: false,
    };
  },
  methods: {
    getDataUser() {
      let lsUser = this.getDataStorageUser()
      if (lsUser) {
        this.userData = lsUser
      } else {
        this.$router.push('/Login')
      }
    },
    getDataTopUp () {
      this.dataSlipReady = false
      this.topUpItems = []
      let uc = ""
      if (this.userData.userCode) { uc = '&userCode=' + this.userData.userCode }
      axios
        .get(
          // eslint-disable-next-line quotes
          'https://licm-cargo.com/api/Slip_top_up/Slip_top_up_list?userName=' +
          this.userData.userName +
          '&userType=' +
          this.userData.userType +
          // uc,
          uc +
          '&status=รอยืนยันการเติมเงิน',
          // '&top=50',
          {
            headers: this.getHeaderAPI('Slip_top_up_list', this.userData.userName)
          }
        )
        .then((response) => {


          let rs = response.data
          if (rs.status === true){
            if (rs.data.length > 0) {
              // this.totalRows = rs.data.length
              for (let i = 0; i < rs.data.length; i++) {
                let topUpData = rs.data[i]

                // topUpData.createDatetime = this.formatDateTime(rs.data[i].CREATE_DATE)
                this.topUpItems.push(topUpData)
                // if (topUpData.status === 'รอยืนยันการเติมเงิน'){
                //   this.topUpItems.push(topUpData)
                // } else {
                //   topUpData.lastDatetime = this.formatDateTime(rs.data[i].LAST_DATE)
                //   this.approveItems.push(topUpData)
                // }
              }
            }
          }

          this.dataSlipReady = true
          this.dataReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('getDataTopUp error:', error)
          this.dataSlipReady = true
          this.topUpItems = []
        });
    },
    getDataApproveTopUp () {
      this.dataApproveReady = false
      this.approveItems = []
      let uc = ""
      if (this.userData.userCode) { uc = '&userCode=' + this.userData.userCode }
      axios
        .get(
          // eslint-disable-next-line quotes
          'https://licm-cargo.com/api/Slip_top_up/Slip_top_up_list?userName=' +
          this.userData.userName +
          '&userType=' +
          this.userData.userType +
          // uc,
          uc +
          '&status=ยืนยันยอดเงิน'+
          '&top=20',
          {
            headers: this.getHeaderAPI('Slip_top_up_list', this.userData.userName)
          }
        )
        .then((response) => {
          let rs = response.data
          if (rs.status === true){
            if (rs.data.length > 0) {
              // this.totalRows = rs.data.length
              for (let i = 0; i < rs.data.length; i++) {
                let topUpData = rs.data[i]

                topUpData.lastDatetime = this.formatDateTime(rs.data[i].LAST_DATE)
                this.approveItems.push(topUpData)
              }
            }
          }

          this.dataApproveReady = true
          // this.dataReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('getDataTopUp error:', error)
          this.dataApproveReady = true
          this.approveItems = []
        });
    },
    approveTopUp (dt) {
      var name = dt.userCode || dt.firstName + " " + dt.lastName
      var money = dt.amount

      this.$swal({
        title: 'ยืนยันการเติมเงิน',
        text: 'คุณต้องการเพิ่มเงินจำนวน ' + money + ' บาทในระบบของ ' + name + ' ใช่หรือไม่?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: 'ยืนยัน'
      }).then((result) => {
        if (result.isConfirmed) {
          let dtUpdate = {
            "status": "ยืนยันยอดเงิน",
            "userCode": dt.userCode,
            "SlipTopUpId": dt.SlipTopUpId,
            "userName": this.userData.userName,
            "LAST_USER": this.userData.userName
          }
          this.onUpdate(dtUpdate)
        }
      })
    },
    cancelTopUp (dt) {
      var name = dt.userCode || dt.firstName + " " + dt.lastName
      var money = dt.amount

      this.$swal({
        title: 'ยกเลิกการเติมเงิน',
        text: 'คุณยกเลิกเติมเงินจำนวน ' + money + ' บาทในระบบของ ' + name + ' ใช่หรือไม่?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: 'ยืนยัน'
      }).then((result) => {
        if (result.isConfirmed) {
          let dtUpdate = {
            "status": "ยกเลิกยอดเงิน",
            "userCode": dt.userCode,
            "SlipTopUpId": dt.SlipTopUpId,
            "userName": this.userData.userName,
            "LAST_USER": this.userData.userName
          }
          this.onUpdate(dtUpdate)
        }
      })
    },
    onUpdate (dt){
      this.dataReady = false
      axios
        .post(
          // eslint-disable-next-line quotes
          "https://licm-cargo.com/api/Slip_top_up/Slip_top_up_update_status",
          dt,
          {
            headers: this.getHeaderAPI('Slip_top_up_update_status', dt.userName, dt.SlipTopUpId)
          }
        )
        .then(async (response) => {
          // console.log('onUpdate Refill', response)
          let rs = response.data
          if (rs.status === true) {
            this.$swal("สำเร็จ","ทำรายการ" + dt.status + "เรียบร้อย","success")
            this.dataReady = true

            this.getDataTopUp()
          } else {
            this.$swal("ผิดพลาด","ไม่สามารถทำรายการ" + dt.status + "ได้","error")
            this.dataReady = true
          }
        })
        .catch((error) => {
          console.log(error.response)
          const { data } = error.response
          if (data) {
            this.$swal("ผิดพลาด",`ไม่สามารถทำรายการ ${dt.status} ได้ ${data.message ? `: ${data.message}` : ""}`, "error")
            this.getDataTopUp()
          } else {
            this.$swal("ผิดพลาด","ไม่สามารถทำรายการ" + dt.status + "ได้","error")
          }
          this.dataReady = true
        })
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#form-profile {
  text-align: left;
}

div.language-bar {
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Refill.vue